import Vue from "vue";

export class SoundEffectPlayer {
  constructor({cooldown = 1000, volume = 1.0}) {
    this.data = Vue.observable({
      cooldown: cooldown,
      canPlay: true,
      volume: volume
    })
    this.soundEffects = {
      amendmentNotification: new Audio(require('../../sounds/notification-01.m4a')),
      candidacyNotification: new Audio(require('../../sounds/notification-02.m4a')),
      commentNotification: new Audio(require('../../sounds/notification-03.m4a'))
    }
  }

  playAmendmentNotification(){
    this.play(this.soundEffects.amendmentNotification)
  }

  playCandidacyNotification(){
    this.play(this.soundEffects.candidacyNotification)
  }

  playCommentNotification(){
    this.play(this.soundEffects.commentNotification)
  }

  play(sfx) {
    if(this.data.canPlay){
      this.data.canPlay = false
      setTimeout((that)=>{
        that.data.canPlay = true
      }, this.data.cooldown, this)
      sfx.volume = this.data.volume
      sfx.play()
    }
  }
}